// Tokens du portail Pilotage (handoff §1). JS pur : importable par les sélecteurs, l'export et les composants.

export const NAVY = '#213067';
export const NAVY_VARIANTE = '#0F2D69';
export const TEXTE = '#2D333B';
export const TEXTE_SECONDAIRE = '#6B7480';
export const TITRE_SECTION = '#8A929C';
export const VERT_PROGRESSION = '#87BC26';
export const PISTE_PROGRESSION = '#E6EAEE';

export const FOND_PAGE = 'linear-gradient(180deg, #F8F9F4 0%, #F3F6EC 45%, #E4EED2 100%)';

export const CARTE = {
    fond: '#FFFFFF',
    bordure: '#E3E7EC',
    separateur: '#EEF1F4',
    radius: 16,
    ombre: '0 1px 2px rgba(16,46,105,.06), 0 1px 3px rgba(16,46,105,.05)',
};

export const TYPO = {
    famille: '"Open Sans", sans-serif',
    // Poids chargés dans Layout.css : 400 / 500 / 600 / 700 / 800.
    poids: {normal: 400, moyen: 500, semi: 600, gras: 700, extra: 800},
    titreSection: {taille: 11, poids: 700, espacement: '.12em'},
};

export const HEADER = {
    hauteur: 60,
    fond: NAVY,
    ongletActif: 'rgba(255,255,255,.14)',
    rechercheLargeur: 420,
};

// Codes de verdict d'un PAV à T (permalien identique).
export const VERDICTS = ['ras', 'pb', 'imp', 'ni'];

export const VERDICT_LIBELLES = {
    ras: 'RAS',
    pb: 'Problème',
    imp: 'Impossible',
    ni: 'Non inspecté',
};

export const VERDICT_COULEURS = {
    ras: {pastille: '#87BC26', texte: '#5C8316', fond: '#EDF4DB', bordure: '#CFE2A0', bandeau: 'linear-gradient(135deg, #FBFEF6 0%, #EDF4DB 55%, #DCEAB8 100%)'},
    pb: {pastille: '#F39A3F', texte: '#B8641A', fond: '#FDEBD8', bordure: '#F5C89A', bandeau: 'linear-gradient(135deg, #FFFBF6 0%, #FDEBD8 55%, #F9D3AE 100%)'},
    imp: {pastille: '#B22222', texte: '#B22222', fond: '#FBE6E6', bordure: '#EBA8A8', bandeau: 'linear-gradient(135deg, #FFF8F8 0%, #FBE6E6 55%, #F3C3C3 100%)'},
    // `marqueur` : style « no data » des cartes (marqueurs ronds et abribacs) : corps gris, contour plein 1 px, pas de glyphe.
    ni: {pastille: '#B5BCC6', texte: '#8A929C', fond: '#F6F8F4', bordure: '#B5BCC6', bandeau: null, marqueur: {corps: '#C9CFD6', contour: '#6B7480'}},
};

// Verdict d'un événement (JSON lot 1) -> code de verdict de PAV.
export const VERDICT_EVENEMENT_VERS_PAV = {ras: 'ras', probleme: 'pb', impossible: 'imp'};

export const ACTES = ['lavage', 'maint', 'graffiti', 'collecte'];

export const ACTE_LIBELLES = {
    lavage: 'Lavage',
    maint: 'Maintenance préventive',
    graffiti: 'Graffiti',
    collecte: 'Collecte',
};

// Marron « camion » de la collecte (timeline de la fiche, pilule d'acte).
const TIMELINE_COLLECTE = '#7A4B2A';

// Couleurs par nature d'acte (handoff §1). `rond` absent pour graffiti et problème.
export const ACTE_COULEURS = {
    lavage: {encre: '#0F2D69', fond: '#E7ECF6', rond: '#0F2D69'},
    maint: {encre: '#3E6B67', fond: '#DCE8E6', rond: '#538A85'},
    graffiti: {encre: '#9A6E00', fond: '#FBF1D2', rond: null},
    collecte: {encre: TIMELINE_COLLECTE, fond: '#F1E6DC', rond: TIMELINE_COLLECTE},
    // Collecte déclassée (bac collecté en OM) : même rouge que « problème ».
    collecteImpossible: {encre: '#B22222', fond: '#FBE6E6', bordure: '#F0BDBD', rond: null},
    probleme: {encre: '#B22222', fond: '#FBE6E6', bordure: '#F0BDBD', rond: null},
};

// Timeline de l'historique : pastille par type de ligne.
export const TIMELINE = {
    trait: '#E3E7EC',
    lavage: '#0F2D69',
    maintenance: '#F39A3F',
    impossible: '#B22222',
    graffiti: '#9A6E00',
    planifie: '#B5BCC6',
    collecte: TIMELINE_COLLECTE,
};

// Étiquettes de photo : pilule 11 px, majuscules, texte blanc.
export const PHOTO_ETIQUETTES = {
    AVANT: '#213067',
    APRES: '#88bc24',
    IMPOSSIBLE: '#B22222',
    MAINTENANCE: ACTE_COULEURS.maint.rond,
    GRAFFITI: ACTE_COULEURS.graffiti.encre,
    PROBLEME: ACTE_COULEURS.probleme.encre,
};

export const MARQUEUR = {
    taille: 26,
    tailleSelection: 32,
    lisere: '2px solid #FFFFFF',
    ombre: '0 1px 4px rgba(16,46,105,.3)',
    halo: 'rgba(243,154,63,.35)',
    cluster: {fond: '#FFFFFF', bordure: `3px solid ${NAVY}`, poids: 700},
};

// `chalandise` (lot 12) : cercle de rayon `rayon` autour de chaque PAV, rempli selon la population allouée.
// `tonnage` : heatmap du remplissage moyen (clé historique conservée), réservé à l'acte collecte (lot 8).
export const CARTE_STYLES = ['points', 'clusters', 'grille', 'heatmap', 'aplat', 'abribacs', 'tonnage', 'chalandise', 'causes'];
// `causes` (lot 11) : couleur du PAV = sa cause dominante sur la plage (selectors/variation.js), réservé à l'acte collecte comme `tonnage`.
export const CAUSE_COULEURS = {
    retiree: '#8A929C', condamnee: '#B22222', defaut: '#EF9F27', nouvelle: '#87BC26', residuBaisse: '#2F6FD0', residu: '#C9CFD6',
};
// Style par défaut de la carte (clé absente du permalien).
export const CARTE_STYLE_DEFAUT = 'abribacs';
// Cible de remplissage des PAV (centre de la rampe divergente de la carte, acte collecte).
export const CIBLE_REMPLISSAGE = 0.33;
export const CARTE_FONDS = ['plan', 'photo'];

// Couleur d'un circuit (C1) : angle d'or sur le rang du patrimoine, luminosité selon rang mod 4.
export const CIRCUIT_COULEUR = {angle: 137.508, saturation: 62, luminosites: [36, 44, 52, 60], luminositeClair: 88};
